import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { MdChevronRight } from 'react-icons/md';
import { selectEvent } from './../../../actions/EventActions';
import { userFetchSuccess } from './../../../actions/UserActions';
import { clearCart } from './../../../actions/CartActions';
import eventStartEndFormat from './../../../utils/eventStartEndFormat';
import PartnerSelectModal from '../../Modals/PartnerSelectModal/PartnerSelectModal';
import { Button } from 'react-bootstrap';
import './EventsListItem.scss';

import { getUploadsBaseUrl } from '../../../api/axiosInstance';

function EventsListItem(props) {
    const { t } = useTranslation();
    const { event, user } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const [ modalShow, setModalShow ] = useState(false);
    const { partnerPortal } = event;
    let partnerLogoUrl = false;

    if (partnerPortal && partnerPortal.logoMaterialID && partnerPortal.logoMaterialID.length) {
        partnerLogoUrl = `${getUploadsBaseUrl()}/uploads/materials/${localStorage.getItem('organizationID')}/${partnerPortal.logoMaterialID}`;
    }

    /**
     * Handle event select
     * Show partner selection modal, if user is part of multiple partners in same event
     * Otherwise, set selected partnerID to localStorage (only 1 partner), update user in state, so that userNav is up to date with current partner, and navigate to event
     */
    function _handleEventSelect(event) {
        if (event && event.partners && event.partners.length > 1) {
            setModalShow(true)
        } else {
            dispatch(selectEvent(event));
            dispatch(userFetchSuccess({ ...user.data }));
            localStorage.setItem('partnerID', event.partners[0].partnerID);
            history.push(`/events/${event.eventID}`);
        }
    }

    /**
     * Select partner and enter event (if user is partneruser in multiple partners within same event)
     * set orderID to null in localStorage
     * also update user in state, so that userNav is up to date with current partner
     */
    function selectPartnerAndEnterEvent(event, partner) {
        localStorage.removeItem('orderID');
        localStorage.setItem('partnerID', partner.partnerID);

        // in case user has been added to new partner in same even, and user data has not updated yet with this partner (no refresh, very borderline case..)
        let userData = { ...user.data };
        const userPartnerFound = user.data.partners.findIndex(p => p.partnerID === partner.partnerID) > -1;

        if (!userPartnerFound) {
            userData = {
                ...userData,
                partners: [
                    ...userData.partners,
                    ...[{ name: partner.name, partnerID: partner.partnerID }]
                ]
            }
        }

        dispatch(clearCart());
        dispatch(userFetchSuccess(userData));
        dispatch(selectEvent(event));

        history.push(`/events/${event.eventID}`);
    }

    return (
        <div className="card EventListItem">
            <div className="card-body" onClick={() => _handleEventSelect(event)}>
                <time dateTime="2014-09-20" className="icon">
                    {event.eventStarts ?
                        <div>
                            <span className="month green">{moment(event.eventStarts).format('MMM')}</span>
                            <span className="dayNumber">{moment(event.eventStarts).format('D')}</span>
                            <em className="dayName">{moment(event.eventStarts).format('ddd')}</em>
                        </div>
                    : <span className="dayNumber">-</span>}
                    
                </time>
                <div className="row">
                    <div className="col">
                        <p className="event-name"><strong>{event.name}</strong><br />
                            {eventStartEndFormat(event)}{(event.venue && event.venue.name) && ', ' + event.venue.name}<br />
                            <Button className="card-link" onClick={() => _handleEventSelect(event)}>
                                {t('events.enter_event')}
                            </Button>
                        </p>
                    </div>

                    <div className="col d-flex align-items-center justify-content-center">
                        {partnerLogoUrl ?
                            <img
                                className="card-img img-fluid"
                                src={partnerLogoUrl}
                                alt="partner logo"
                                style={{ maxHeight: '150px', width: 'auto', flexShrink: 0 }}
                            />
                        : null}
                    </div>

                    <div className="col d-flex align-items-center justify-content-end pr-0">
                        <Button variant="light" className="arrow-link" onClick={() => _handleEventSelect(event)}>
                            <MdChevronRight />
                        </Button>
                    </div>
                </div>
            </div>
            <PartnerSelectModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                event={event}
                callback={selectPartnerAndEnterEvent}
            />
        </div>
    )
}

EventsListItem.propTypes = {
    event: PropTypes.object
}

export default memo(EventsListItem);